import css from 'styled-jsx/css'

export const styles = css`
  .bar-container {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 3;
    margin: 0 auto;
    box-shadow: 0 -2px 7px 0px rgba(0, 0, 0, 0.09);
    background-color: #fff;
  }

  .bar-container__buttonList {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 48px;
    max-width: 600px;
    margin: 0 auto;
  }

  .bar-container__buttonList__button {
    cursor: pointer;
    width: calc(100% / 3);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1px 0 -4px;
    color: #666;
    font-size: 0.8em;
  }

  .left_and_right_border {
    border-width: 1px;
    border-style: solid;
    border-color: transparent #eee;
  }

  .bar-container__buttonList__button-margin {
    margin: 0 6px;
  }
`
